import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Icons

import { X } from "react-feather";

const toastVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 0.8,
      delay: 0,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 0.8,
      delay: 0,
    },
  },
};

const CustomToast = ({ _isShown, setActivateToast, toastProps }) => {
  const [animationStatus, setAnimationStatus] = useState(false);

  let toastrTimeout = setTimeout(() => {
    setAnimationStatus(false);
  }, 3000);

  let deactivateToast = setTimeout(() => {
    setActivateToast(false);
  }, 3800);

  useEffect(() => {
    clearTimeout(toastrTimeout);

    if (_isShown) {
      setAnimationStatus(true);
    }

    return () => {
      clearTimeout(toastrTimeout);
    };
  }, [_isShown, setActivateToast]);
  return (
    <motion.div
      className={`toast ${toastProps === null ? "" : toastProps.style}`}
      variants={toastVariants}
      initial='initial'
      animate={animationStatus ? "animate" : ""}
      exit='exit'
    >
      <motion.div className='text-message'>
        {toastProps === null ? "" : toastProps.message}
      </motion.div>
      <motion.div
        className='btn-close'
        style={{ cursor: "pointer" }}
        whileHover={{
          scale: 1.2,
          transformOrigin: "center",
        }}
        onClick={() => {
          setActivateToast(false);
        }}
      >
        <X />
      </motion.div>
      <motion.div className='indicator'></motion.div>
    </motion.div>
  );
};

export default CustomToast;
